import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Popper, IconButton, Box, ClickAwayListener } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import { useTranslate } from 'react-admin';


export default function PositionedPopper({ title, content, icon, color }) {
    const [open, setOpen] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const translate = useTranslate()
    const useStyles = makeStyles(theme => ({
        typography: {
            padding: theme.spacing(2)
        },
        arrow: {
            position: "absolute",
            marginTop: '1em',
            fontSize: 15,
            width: "3em",
            height: "1em",

            "&::before": {
                content: '""',
                margin: "auto",
                display: "block",
                width: 0,
                height: 0,
                borderStyle: "solid"
            }
        }, title: {
            fontFamily: 'UniviaPro-Bold',
            fontSize: '14px',
            fontWeight: 500,
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 2.14,
            letterSpacing: ' 0.15px',
            color: '#4f5064',
        },
        Text: {
            fontFamily: 'UniviaPro',
            fontSize: '12px',
            fontWeight: 'normal',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 1.6,
            letterSpacing: '0.5px',
            color: '#88898c',
        },
        popper: {
            zIndex: 100000,
            marginLeft: "2em",
            marginTop: '2em',
            width: 200,
            borderRadius: "20px",
            boxShadow: '0 10px 35px 0 rgba(0, 0, 0, 0.1), 0 15px 10px 0 rgba(0, 0, 0, 0.02)',
            '&[x-placement*="right"] $arrow': {
                left: 0,
                marginLeft: "-0.9em",
                height: "3em",
                width: "1em",
                "&::before": {
                    borderWidth: "1em 1em 1em 0",
                    borderColor: `transparent ${theme.palette.background.paper
                        } transparent transparent`
                }
            },


        },
        textbtn: {
            fontFamily: 'UniviaPro',
            fontSize: '10px',
            fontWeight: 'normal',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 1.25,
            letterSpacing: '0.4px',
            color:  theme.palette.primary.main,
        },
        borderIcon: {
            borderRadius: '8px',
            // border: ' solid 1px #e0f0f2',
            backgroundColor: color ? color :theme.palette.grey.A700,
            color: theme.palette.primary.main,
            "&:hover": {
                backgroundColor: theme.palette.grey.A700
            },
        }
    }));
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const [arrowRef, setArrowRef] = React.useState(null);
    const classes = useStyles();

    return (

        <ClickAwayListener onClickAway={handleClose}>
            <div tabIndex='-1'>
                <Popper
                    className={classes.popper}
                    open={open}
                    anchorEl={anchorEl}
                    placement="right"
                    transition
                    modifiers={{

                        arrow: {
                            enabled: true,
                            element: arrowRef
                        }
                    }}
                >
                    <span className={classes.arrow} ref={setArrowRef} />
                    <Paper>
                        <Box pl={2} pr={1} py={1}>
                            <Box>
                                <Typography className={classes.title}>{title}</Typography>
                            </Box>
                            <Box my={1}>
                                <Typography className={classes.Text}>
                                    {content}
                                </Typography>
                            </Box>
                            <Box display='flex' justifyContent='flex-end'>
                                <Button className={classes.textbtn} onClick={handleClose} size='small'>{translate(`pos.user.close`)}</Button>
                            </Box>
                        </Box>

                    </Paper>
                </Popper>
                <IconButton tabIndex='-1' onClick={handleClick} size='small' className={classes.borderIcon} style={{ padding: '2px 6px' }}>
                    {icon}
                </IconButton>
            </div>
        </ClickAwayListener>

    );
}
